//import React from "react";
import BaseAPIs from "./base.apis";
import axios, {CancelTokenSource} from "axios";
import {iApiBasicResponse} from "../types/api";
import {iEmailAutomation} from "../types/internal";
import {iEmailCampaign} from "../types/internal/email/campaign";
import {iEmailMailingList} from "../types/internal/email/mailinglist";
import {iEmailSegment} from "./Email/email.segmentation";
import {iShopifyReview} from "./review.apis";
//import {iChatSession, iSendMessage} from "./ChatGuest/chat.client";
import {ObjectFlatter} from "./resource.apis";
import { iFetchUserResponse } from "./user.apis";
import { setEmailwishApiToken } from "../utils/emailwishApiToken";
export interface SearchResponse extends iApiBasicResponse {
    automations?: iEmailAutomation[],
    campaigns?: iEmailCampaign[],
    mail_lists?: iEmailMailingList[],
    segments?: iEmailSegment[],
}

export interface iReviewResponse extends iApiBasicResponse {
    review?: iShopifyReview
}

export default class CommonApis extends BaseAPIs {
    search = async (keyword: string | undefined, source: CancelTokenSource): Promise<SearchResponse> => {
        return axios
            .get(this.getApiBaseURL() + "/global_search", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
                cancelToken: source.token,
                params: {
                    search: keyword,
                    ts: new Date().getTime()
                }
            })
            .then((res): SearchResponse => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    }

    get_review = async (uid: string, secret_key: string): Promise<iApiBasicResponse> => {

        return axios
            .get(this.getApiBaseURL() + `/_shopify/review/${uid}/${secret_key}`, {
                withCredentials: true,
            })
            .then((res): iApiBasicResponse => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    };

    update_review = async (uid: string, secret_key: string,values:any,onUploadProgress?: (progressEvent: ProgressEvent) => void): Promise<iReviewResponse> => {
        let csrfToken: string = await new BaseAPIs().getCsrfToken();
        if (!csrfToken) return {statusCode: 999, errors: {network: "Network error!"}};
        let fd = new FormData();

        let flattenedParams = new ObjectFlatter(values);
        flattenedParams.get_form_data().forEach(entry => {

            fd.set(entry.key, entry.value);
        });
        fd.delete("images");
        if (values.images && values.images.length > 0) {
            for (let i = 0; i < values.images.length; i++) {
                fd.set(`images[${i}]`, values.images[i]);
            }
        }
        fd.set(`_token`, csrfToken);
        return axios
            .post(this.getApiBaseURL() + `/_shopify/review/${uid}/${secret_key}`, fd, {
                headers: {"Content-Type": "multipart/form-data"},
                withCredentials: true,
                onUploadProgress: values.images && values.images.length>0 && onUploadProgress
            })
            .then((res): iApiBasicResponse => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    };

    after_login = async (response : iFetchUserResponse, dispatch: any) => {
        if (!response.user) {
            return;
        }

        const shops = response.shops || [];

        localStorage.setItem('logged_in', 'true')
        sessionStorage.removeItem('login_session_cleared')
        setEmailwishApiToken(response.user?.api_token)

        // Hydrate shops before user so PrivateRoute never sees "logged in, no shops"
        // mid-dispatch (that path clears the session and sends users to /login).
        dispatch({
            type: "set_shops",
            shops: shops,
        })

        let plans = response.plans && response.plans.map((value => {
            let options_object = {};
            try {
                options_object = value.options ? JSON.parse(value.options) : {};
            } catch {
                options_object = {};
            }
            return { ...value, options_object: options_object }
        }))
        dispatch({
            type: "set_plans",
            plans: plans,
        })

        if (shops.length > 0) {
            let set_active_shop_uid = response?.user?.shop ?? window.localStorage.getItem("set_active_shop_uid");
            if (set_active_shop_uid && set_active_shop_uid.length > 0) {
                let shop = shops.find(value => {
                    return value.uid === set_active_shop_uid;
                })
                if (shop) {
                    dispatch({
                        type: "set_active_shop",
                        shop: shop
                    })
                    dispatch({
                        type: "set_profile_setting",
                        profileSetting: shop?.customer?.profile_setting ?? null
                    })
                } else {
                    let shop2 = shops[shops.length - 1];
                    dispatch({
                        type: "set_active_shop",
                        shop: shop2
                    })
                    dispatch({
                        type: "set_profile_setting",
                        profileSetting: shop2?.customer?.profile_setting ?? null
                    })
                }
            } else {
                dispatch({
                    type: "set_active_shop",
                    shop: shops[shops.length - 1]
                })
            }
        }

        dispatch({
            type: "set_logged_in_user",
            loggedInUser: response.user
        })
    };
}
